import { render, staticRenderFns } from "./industryTargetTabs.vue?vue&type=template&id=b0e8f7c8&scoped=true"
import script from "./industryTargetTabs.vue?vue&type=script&lang=js"
export * from "./industryTargetTabs.vue?vue&type=script&lang=js"
import style0 from "./industryTargetTabs.vue?vue&type=style&index=0&id=b0e8f7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e8f7c8",
  null
  
)

export default component.exports